// @flow

import { connect } from 'react-redux';

import { fetchFidBadges } from 'actions/fidActions';
import FidExplanationBadges from 'components/profile/Fidelite/fidExplanationBadges';
import type { StateType, DispatchType } from 'types/Actions';
import type { StateProps, DispatchProps } from 'components/profile/Fidelite/fidExplanationBadges';
import { withRouter } from 'react-router-dom';

export default withRouter(
  connect(
    (state: StateType): StateProps => ({
      fidBadgesData: state.fidState.fid_badges_data,
      fidBadgesStatus: state.fidState.fid_badges_status
    }),
    (dispatch: DispatchType): DispatchProps => ({
      fetchFidBadges: () => dispatch(fetchFidBadges())
    })
  )(FidExplanationBadges)
);
